import {
  PRODUCT_PDF_SERVICES,
  PRODUCT_WORKFLOWS,
  PRODUCT_E_SIGN,
  PRODUCT_WEBFORMS,
  PRODUCT_DOCUMENT_AI,
} from '@anvilco-pkg/sanity'

export function getPagePath ({ prefixSlug, tagSlug, pageSlug }) {
  const lowerCaseTagSlug = tagSlug.toLowerCase()
  const lowerCasePageSlug = pageSlug.toLowerCase()
  const lowerCasePrefixSlug = prefixSlug.toLowerCase()
  return tagSlug
    ? getTaggedPath({
        prefixSlug: lowerCasePrefixSlug,
        tagSlug: lowerCaseTagSlug,
        pageSlug: lowerCasePageSlug,
      })
    : getUntaggedPath({
        prefixSlug: lowerCasePrefixSlug,
        pageSlug: lowerCasePageSlug,
      })
}

function getTaggedPath ({ prefixSlug, tagSlug, pageSlug }) {
  return `/${prefixSlug}/${tagSlug}/${pageSlug ? `${pageSlug}/` : ''}`
}

function getUntaggedPath ({ prefixSlug, pageSlug }) {
  return `/${prefixSlug}/${pageSlug ? `${pageSlug}/` : ''}`
}

const PRODUCT_TAGS_MAP = {
  [PRODUCT_PDF_SERVICES]: 'pdf-services',
  [PRODUCT_WORKFLOWS]: 'workflows',
  [PRODUCT_E_SIGN]: 'etch',
  [PRODUCT_WEBFORMS]: 'webforms',
  [PRODUCT_DOCUMENT_AI]: 'document-ai',
}

export function getProductSlug (productTag) {
  return PRODUCT_TAGS_MAP[productTag]
    ? PRODUCT_TAGS_MAP[productTag]
    : productTag
}
